(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["the-method"] && !Shopify.designMode) return;
  try {
    
(function () {
  var COMBINE_GAP_THRESHOLD = 1;
  var OUT_DURATION = 120;
  var IN_DURATION = 240;
  var HEIGHT_DURATION = 240;
  var SELECT_DELAY = 160;
  var ANALYZING_DURATION = 1400;
  var MAX_MULTIPLE = 2;
  var STORAGE_TTL = 7 * 24 * 60 * 60 * 1000;

  var reducedMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');

  function animate(el, keyframes, duration, easing, delay) {
    if (!el || !el.animate || reducedMotionQuery.matches) {
      return Promise.resolve();
    }
    try {
      return el.animate(keyframes, { duration: duration, easing: easing || 'ease', delay: delay || 0 }).finished.catch(function () {});
    } catch (e) {
      return Promise.resolve();
    }
  }

  function track(name, detail) {
    try {
      (window.dataLayer = window.dataLayer || []).push(Object.assign({ event: 'the_method_' + name }, detail || {}));
      document.dispatchEvent(new CustomEvent('the-method:' + name, { detail: detail || {} }));
    } catch (e) {}
  }

  function vibrate() {
    if (navigator.vibrate && !reducedMotionQuery.matches) {
      try { navigator.vibrate(8); } catch (e) {}
    }
  }

  function initInstance(wrapper) {
    var sectionId = wrapper.getAttribute('data-section-id');
    var storageKey = 'the-method:' + sectionId + ':v1';
    var requireEmail = wrapper.getAttribute('data-require-email') === 'true';

    var options = Array.prototype.slice.call(wrapper.querySelectorAll('[data-the-method-option]'));
    var toneRanges = Array.prototype.slice.call(wrapper.querySelectorAll('[data-the-method-tone]'));
    var startButton = wrapper.querySelector('[data-the-method-start]');
    var backButton = wrapper.querySelector('[data-the-method-back]');
    var restartButton = wrapper.querySelector('[data-the-method-restart]');
    var progressWrapper = wrapper.querySelector('[data-the-method-progress]');
    var progressCurrent = wrapper.querySelector('[data-the-method-progress-current]');
    var progressFill = wrapper.querySelector('[data-the-method-progress-fill]');
    var resultCards = wrapper.querySelectorAll('[data-the-method-result]');
    var contextNotes = wrapper.querySelectorAll('[data-the-method-context-note]');
    var warningEl = wrapper.querySelector('[data-the-method-warning]');
    var summaryEl = wrapper.querySelector('[data-the-method-summary]');
    var extrasEl = wrapper.querySelector('[data-the-method-extras]');
    var panelsEl = wrapper.querySelector('[data-the-method-panels]');
    var formEl = wrapper.closest('form');

    var STEPS = Array.prototype.slice.call(wrapper.querySelectorAll('[data-the-method-panel]')).map(function (panel) {
      return panel.getAttribute('data-the-method-panel');
    });
    var totalFlowSteps = STEPS.filter(function (key) { return key.indexOf('step-') === 0; }).length;

    var busy = false;
    var analyzingTimer = null;

    // answers[step] = list of records (one for single choice, up to MAX_MULTIPLE for multiple choice)
    var state = {
      scores: { salicylic: 0, tca: 0 },
      format: null,
      notes: [],
      warnings: [],
      answers: {},
      editing: false
    };

    function panelFor(key) {
      return wrapper.querySelector('[data-the-method-panel="' + key + '"]');
    }

    function optionsForStep(step) {
      return options.filter(function (option) { return option.getAttribute('data-step') === String(step); });
    }

    function isMultiple(step) {
      var panel = panelFor('step-' + step);
      return !!panel && panel.hasAttribute('data-multiple');
    }

    function currentPanelKey() {
      var visible = wrapper.querySelector('[data-the-method-panel]:not([hidden])');
      return visible ? visible.getAttribute('data-the-method-panel') : STEPS[0];
    }

    function recordFromOption(option) {
      var labelEl = option.querySelector('.the-method__option-label');
      return {
        key: option.getAttribute('data-key'),
        label: labelEl ? labelEl.textContent.trim() : (option.getAttribute('aria-label') || ''),
        weightSalicylic: Number(option.dataset.weightSalicylic || 0),
        weightTca: Number(option.dataset.weightTca || 0),
        format: option.dataset.format || '',
        note: option.dataset.note || '',
        warn: option.dataset.warn === 'true',
        warnNote: option.dataset.warnNote || ''
      };
    }

    function answeredCount(step) {
      return (state.answers[step] || []).length;
    }

    function isAnswered(step) {
      return answeredCount(step) > 0;
    }

    // ---- persistence (so a visitor who leaves can come back to where they were) ----
    function saveProgress(panelKey) {
      try {
        var answers = {};
        Object.keys(state.answers).forEach(function (step) {
          answers[step] = state.answers[step].map(function (record) { return record.key; });
        });
        localStorage.setItem(storageKey, JSON.stringify({ answers: answers, panel: panelKey || currentPanelKey(), ts: Date.now() }));
      } catch (e) {}
    }

    function clearProgress() {
      try { localStorage.removeItem(storageKey); } catch (e) {}
    }

    // ---- selection state in the DOM ----
    function toneColorsFor(range) {
      return (range.parentElement.getAttribute('data-tone-colors') || '').split(',');
    }

    function paintTone(range) {
      var colors = toneColorsFor(range);
      var index = Math.min(Math.max(Number(range.value), 1), colors.length) - 1;
      if (colors[index]) {
        range.parentElement.style.setProperty('--tone-color', colors[index]);
      }
      range.setAttribute('aria-valuetext', 'Tono ' + range.value + ' de ' + colors.length);
    }

    function updateContinue(step) {
      var panel = panelFor('step-' + step);
      var wrap = panel && panel.querySelector('[data-the-method-continue]');
      if (!wrap) return;
      var button = wrap.querySelector('button, a');
      if (button) button.disabled = !isAnswered(step);
    }

    function applySelectedState(step) {
      var selectedKeys = (state.answers[step] || []).map(function (record) { return record.key; });
      optionsForStep(step).forEach(function (option) {
        option.setAttribute('aria-checked', selectedKeys.indexOf(option.getAttribute('data-key')) !== -1 ? 'true' : 'false');
      });
      toneRanges.forEach(function (range) {
        if (range.getAttribute('data-step') !== String(step)) return;
        var record = (state.answers[step] || [])[0];
        if (record) {
          range.value = record.key.split('-tone-')[1] || range.value;
        }
        paintTone(range);
      });
      updateContinue(step);
    }

    // Recomputes scores/format/notes/warnings from scratch from the answers, so going back and changing one never doubles anything.
    function recomputeFromAnswers() {
      var scores = { salicylic: 0, tca: 0 };
      var format = null;
      var notes = [];
      var warnings = [];

      Object.keys(state.answers).forEach(function (step) {
        (state.answers[step] || []).forEach(function (record) {
          scores.salicylic += record.weightSalicylic;
          scores.tca += record.weightTca;
          if (record.format && record.format !== 'auto') format = record.format;
          if (record.note) notes.push(record.note);
          if (record.warn && record.warnNote) warnings.push(record.warnNote);
        });
      });

      state.scores = scores;
      state.format = format;
      state.notes = notes;
      state.warnings = warnings;
    }

    // The banner opens and closes smoothly (height + fade) instead of popping in and pushing everything down at once.
    function updateWarningBanner() {
      if (!warningEl) return;
      var unique = state.warnings.filter(function (note, index) {
        return note && state.warnings.indexOf(note) === index;
      });

      if (unique.length === 0) {
        if (warningEl.hidden) return;
        var closedFrom = warningEl.offsetHeight;
        animate(warningEl, [
          { opacity: 1, height: closedFrom + 'px', paddingBlock: getComputedStyle(warningEl).paddingBlockStart },
          { opacity: 0, height: '0px', paddingBlock: '0px' }
        ], HEIGHT_DURATION, 'ease-in-out').then(function () {
          if (state.warnings.length === 0) {
            warningEl.hidden = true;
            warningEl.textContent = '';
          }
        });
        return;
      }

      var text = unique.join(' ');
      if (!warningEl.hidden) {
        warningEl.textContent = text;
        return;
      }

      warningEl.textContent = text;
      warningEl.hidden = false;
      var openTo = warningEl.offsetHeight;
      animate(warningEl, [
        { opacity: 0, height: '0px', paddingBlock: '0px' },
        { opacity: 1, height: openTo + 'px', paddingBlock: getComputedStyle(warningEl).paddingBlockStart }
      ], HEIGHT_DURATION, 'ease-in-out');
    }

    function resolveMethod() {
      return state.scores.tca > state.scores.salicylic ? 'tca' : 'salicylic';
    }

    function resolveFormat() {
      if (state.format) return state.format;
      return Math.abs(state.scores.salicylic - state.scores.tca) <= COMBINE_GAP_THRESHOLD ? 'combo' : 'single';
    }

    // Each result declares which method/format it answers to ("any" = wildcard); the most specific match wins.
    function scoreMatch(card, method, format) {
      var cardMethod = card.dataset.matchMethod || 'any';
      var cardFormat = card.dataset.matchFormat || 'any';
      if (cardMethod !== 'any' && cardMethod !== method) return -1;
      if (cardFormat !== 'any' && cardFormat !== format) return -1;
      var score = 0;
      if (cardMethod === method) score += 2;
      if (cardFormat === format) score += 1;
      return score;
    }

    function answersSummaryText() {
      return STEPS.filter(function (key) { return key.indexOf('step-') === 0; }).map(function (key) {
        var step = key.split('-')[1];
        return (state.answers[step] || []).map(function (record) { return record.label; }).join(' + ');
      }).filter(Boolean);
    }

    function renderSummary() {
      if (!summaryEl) return;
      summaryEl.textContent = '';
      STEPS.forEach(function (key) {
        if (key.indexOf('step-') !== 0) return;
        var step = key.split('-')[1];
        var labels = (state.answers[step] || []).map(function (record) { return record.label; }).filter(Boolean);
        if (!labels.length) return;
        var tag = document.createElement('button');
        tag.type = 'button';
        tag.className = 'the-method__summary-tag';
        tag.setAttribute('data-edit-step', key);
        tag.textContent = labels.join(' + ');
        summaryEl.appendChild(tag);
      });
    }

    function visibleResultCard() {
      var found = null;
      resultCards.forEach(function (card) { if (!card.hidden) found = card; });
      return found;
    }

    // The whole result as text: answers and recommended method (with its link)
    function resultText(labels) {
      var lines = [];
      var answerLines = answersSummaryText();
      var card = visibleResultCard();
      var title = card && card.querySelector('h3') ? card.querySelector('h3').textContent.trim() : '';
      var link = card ? card.querySelector('.the-method__result-info a') : null;
      if (answerLines.length) lines.push(labels.answers + ': ' + answerLines.join(' / '));
      if (title) lines.push(labels.result + ': ' + title + (link ? ' - ' + link.href : ''));
      return lines;
    }

    function prepareExtras(best) {
      if (extrasEl) extrasEl.hidden = !best;

      var whatsapp = wrapper.querySelector('[data-the-method-whatsapp]');
      if (whatsapp && best) {
        var link = whatsapp.querySelector('a');
        var lines = [whatsapp.getAttribute('data-message') || ''].concat(resultText({
          answers: whatsapp.getAttribute('data-answers-label') || '',
          result: whatsapp.getAttribute('data-result-label') || ''
        }));
        if (link) {
          link.setAttribute('href', 'https://wa.me/' + whatsapp.getAttribute('data-number').replace(/\D/g, '') + '?text=' + encodeURIComponent(lines.filter(Boolean).join('\n')));
          link.setAttribute('rel', 'noopener');
        }
      }
    }

    function showResult() {
      recomputeFromAnswers();
      updateWarningBanner();

      var method = resolveMethod();
      var format = resolveFormat();

      var best = null;
      var bestScore = -1;
      resultCards.forEach(function (card) {
        var score = scoreMatch(card, method, format);
        if (score > bestScore) {
          bestScore = score;
          best = card;
        }
      });

      resultCards.forEach(function (card) {
        card.hidden = bestScore < 0 || card !== best;
      });

      var note = state.notes.filter(Boolean).join(' ');
      contextNotes.forEach(function (el) {
        el.textContent = note;
      });

      renderSummary();
      prepareExtras(bestScore < 0 ? null : best);
      track('result', { method: method, format: format });
    }

    function updateControls(panelKey) {
      var isIntro = panelKey === 'intro';
      var isAnalyzing = panelKey === 'analyzing';
      var isQuestion = panelKey.indexOf('step-') === 0;

      if (backButton) backButton.hidden = isIntro || isAnalyzing;
      if (restartButton) restartButton.hidden = isIntro || isAnalyzing;
      if (progressWrapper) progressWrapper.hidden = isIntro;

      // The intro image is only seen on the intro: when the test moves on, the section collapses to a single column.

      if (progressFill && totalFlowSteps > 0) {
        if (isQuestion) {
          var stepNumber = panelKey.split('-')[1];
          if (progressCurrent) progressCurrent.textContent = stepNumber.length < 2 ? '0' + stepNumber : stepNumber;
          progressFill.style.width = (Number(stepNumber) / totalFlowSteps) * 100 + '%';
        } else if (isAnalyzing || panelKey === 'result') {
          progressFill.style.width = '100%';
        }
      }
    }

    var supportsViewTransitions = typeof document.startViewTransition === 'function';

    function swapPanels(fromEl, toEl, panelKey) {
      if (fromEl) fromEl.hidden = true;
      updateControls(panelKey);
      toEl.hidden = false;
    }

    function finishTransition(toEl, panelKey) {
      if (typeof toEl.focus === 'function') {
        toEl.focus({ preventScroll: true });
      }
      saveProgress(panelKey);
      busy = false;

      if (panelKey === 'analyzing') {
        clearTimeout(analyzingTimer);
        analyzingTimer = setTimeout(function () {
          goTo('result', 1);
        }, reducedMotionQuery.matches ? 0 : ANALYZING_DURATION);
      }
    }

    // One change of panel. With the View Transitions API the area of the panels morphs and cross-fades by itself; otherwise the old panel fades
    // out, the controls and the layout settle, and the new one rises in while the container eases to its height. Clicks that arrive while it
    // runs are ignored (busy), so a double tap can't skip a question.
    function goTo(panelKey, direction) {
      if (busy) {
        return Promise.resolve();
      }

      direction = direction || 1;
      var travel = 8 * direction;

      var fromEl = wrapper.querySelector('[data-the-method-panel]:not([hidden])');
      var toEl = panelFor(panelKey);

      if (!toEl || toEl === fromEl) {
        return Promise.resolve();
      }

      busy = true;

      if (panelKey === 'result') {
        showResult();
      }

      if (panelKey.indexOf('step-') === 0) {
        applySelectedState(panelKey.split('-')[1]);
        track('step', { step: panelKey });
      }

      if (supportsViewTransitions && !reducedMotionQuery.matches) {
        document.documentElement.style.setProperty('--the-method-travel', travel + 'px');
        return new Promise(function (resolve) {
          var transition;
          try {
            transition = document.startViewTransition(function () {
              swapPanels(fromEl, toEl, panelKey);
            });
          } catch (e) {
            swapPanels(fromEl, toEl, panelKey);
            finishTransition(toEl, panelKey);
            resolve();
            return;
          }
          transition.finished.catch(function () {}).then(function () {
            finishTransition(toEl, panelKey);
            resolve();
          });
        });
      }

      var fromHeight = panelsEl ? panelsEl.getBoundingClientRect().height : 0;
      var chain = Promise.resolve();

      if (fromEl) {
        chain = animate(fromEl, [{ opacity: 1 }, { opacity: 0 }], OUT_DURATION, 'ease-out').then(function () {
          fromEl.hidden = true;
        });
      }

      return chain
        .then(function () {
          if (panelsEl) {
            panelsEl.style.height = fromHeight + 'px';
            panelsEl.style.overflow = 'hidden';
          }

          updateControls(panelKey);
          toEl.hidden = false;

          var heightAnimation = Promise.resolve();
          if (panelsEl) {
            heightAnimation = animate(panelsEl, [{ height: fromHeight + 'px' }, { height: panelsEl.scrollHeight + 'px' }], HEIGHT_DURATION, 'ease-in-out');
          }

          return Promise.all([
            heightAnimation,
            animate(toEl, [
              { opacity: 0, transform: 'translateY(' + travel + 'px)' },
              { opacity: 1, transform: 'translateY(0)' }
            ], IN_DURATION, 'cubic-bezier(0.22, 1, 0.36, 1)')
          ]);
        })
        .then(function () {
          if (panelsEl) {
            panelsEl.style.height = '';
            panelsEl.style.overflow = '';
          }
          finishTransition(toEl, panelKey);
        })
        .catch(function () {
          if (panelsEl) {
            panelsEl.style.height = '';
            panelsEl.style.overflow = '';
          }
          busy = false;
        });
    }

    function goToStepIndex(delta) {
      var index = STEPS.indexOf(currentPanelKey());
      var nextIndex = index + delta;
      if (nextIndex >= 0 && nextIndex < STEPS.length && STEPS[nextIndex] === 'analyzing' && delta < 0) {
        nextIndex -= 1;
      }
      if (nextIndex < 0 || nextIndex >= STEPS.length) return;
      goTo(STEPS[nextIndex], delta > 0 ? 1 : -1);
    }

    // After an answer is confirmed: next question, or, when it was edited from the result, straight back to the (recalculated) result.
    function advance() {
      if (state.editing) {
        state.editing = false;
        goTo('result', 1);
      } else {
        goToStepIndex(1);
      }
    }

    function afterAnswer(step) {
      applySelectedState(step);
      recomputeFromAnswers();
      updateWarningBanner();
      saveProgress();
      vibrate();
    }

    // ---- single and multiple choice ----
    options.forEach(function (option) {
      option.addEventListener('click', function () {
        if (busy) return;
        var step = option.getAttribute('data-step');
        var record = recordFromOption(option);
        var current = state.answers[step] || [];

        if (isMultiple(step)) {
          var exists = current.some(function (item) { return item.key === record.key; });
          if (exists) {
            current = current.filter(function (item) { return item.key !== record.key; });
          } else {
            current = current.concat(record);
            if (current.length > MAX_MULTIPLE) current = current.slice(current.length - MAX_MULTIPLE);
          }
          state.answers[step] = current;
          afterAnswer(step);
          track('answer', { step: 'step-' + step, answer: record.label });
          return;
        }

        state.answers[step] = [record];
        afterAnswer(step);
        track('answer', { step: 'step-' + step, answer: record.label });

        // A short beat so the chosen option is seen selected before the next question comes in
        if (reducedMotionQuery.matches) {
          advance();
        } else {
          busy = true;
          setTimeout(function () {
            busy = false;
            advance();
          }, SELECT_DELAY);
        }
      });

      option.addEventListener('keydown', function (event) {
        var isNext = event.key === 'ArrowRight' || event.key === 'ArrowDown';
        var isPrev = event.key === 'ArrowLeft' || event.key === 'ArrowUp';
        if (!isNext && !isPrev) return;

        event.preventDefault();
        var step = option.getAttribute('data-step');
        var stepOptions = optionsForStep(step);
        var currentPos = stepOptions.indexOf(option);
        var direction = isNext ? 1 : -1;
        var nextPos = (currentPos + direction + stepOptions.length) % stepOptions.length;
        stepOptions[nextPos].focus();
      });
    });

    // ---- skin tone scale ----
    // The record of a tone answer: from the "deep tone" the block sets, it can carry a warning and a weight towards one method or the other
    function toneRecord(range, value) {
      var darkFrom = Number(range.getAttribute('data-dark-from') || 7);
      var isDeep = Number(value) >= darkFrom;
      var warning = isDeep ? (range.getAttribute('data-dark-warning') || '') : '';
      return {
        key: range.getAttribute('data-key-prefix') + '-tone-' + value,
        label: 'Tono ' + value,
        weightSalicylic: isDeep ? Number(range.getAttribute('data-dark-weight-salicylic') || 0) : 0,
        weightTca: isDeep ? Number(range.getAttribute('data-dark-weight-tca') || 0) : 0,
        format: '',
        note: '',
        warn: !!warning,
        warnNote: warning
      };
    }

    toneRanges.forEach(function (range) {
      var step = range.getAttribute('data-step');

      function record() {
        paintTone(range);
        state.answers[step] = [toneRecord(range, range.value)];
        recomputeFromAnswers();
        updateWarningBanner();
        updateContinue(step);
        saveProgress();
      }

      range.addEventListener('input', function () {
        paintTone(range);
      });
      range.addEventListener('change', function () {
        record();
        vibrate();
        track('answer', { step: 'step-' + step, answer: 'tono ' + range.value });
      });
      // Tapping the handle without moving it still confirms the tone it is on
      range.addEventListener('click', function () {
        if (!isAnswered(step)) record();
      });
      paintTone(range);
    });

    // ---- continue (multiple choice and tone) ----
    wrapper.querySelectorAll('[data-the-method-continue]').forEach(function (wrap) {
      var panel = wrap.closest('[data-the-method-panel]');
      var button = wrap.querySelector('button, a');
      if (button) button.disabled = true;
      wrap.addEventListener('click', function (event) {
        if (!panel || busy) return;
        var step = panel.getAttribute('data-the-method-panel').split('-')[1];
        if (!isAnswered(step)) return;
        event.preventDefault();
        advance();
      });
    });

    // ---- intro, back, restart ----
    if (startButton) {
      startButton.addEventListener('click', function () {
        track('start');
        goTo(STEPS[1] || 'result');
      });
    }

    if (backButton) {
      backButton.addEventListener('click', function () {
        state.editing = false;
        goToStepIndex(-1);
      });
    }

    if (restartButton) {
      restartButton.addEventListener('click', function () {
        clearTimeout(analyzingTimer);
        state.answers = {};
        state.scores = { salicylic: 0, tca: 0 };
        state.format = null;
        state.notes = [];
        state.warnings = [];
        state.editing = false;
        clearProgress();
        updateWarningBanner();
        options.forEach(function (option) {
          option.setAttribute('aria-checked', 'false');
        });
        toneRanges.forEach(function (range) {
          range.value = 3;
          paintTone(range);
        });
        wrapper.querySelectorAll('[data-the-method-continue]').forEach(function (wrap) {
          var button = wrap.querySelector('button, a');
          if (button) button.disabled = true;
        });
        track('restart');
        goTo('intro', -1);
      });
    }

    // ---- result gallery: the thumbnails change the image shown ----
    wrapper.addEventListener('click', function (event) {
      var thumb = event.target.closest('[data-the-method-thumb]');
      if (!thumb) return;
      var gallery = thumb.closest('[data-the-method-gallery]');
      if (!gallery) return;
      var index = Number(thumb.getAttribute('data-index'));
      gallery.querySelectorAll('.the-method__result-slide').forEach(function (slide, position) {
        slide.classList.toggle('is-active', position === index);
      });
      gallery.querySelectorAll('[data-the-method-thumb]').forEach(function (item) {
        item.setAttribute('aria-selected', item === thumb ? 'true' : 'false');
      });
    });

    // ---- summary tags: back to one question, then straight to the result again ----
    if (summaryEl) {
      summaryEl.addEventListener('click', function (event) {
        var tag = event.target.closest('[data-edit-step]');
        if (!tag || busy) return;
        state.editing = true;
        goTo(tag.getAttribute('data-edit-step'), -1);
      });
    }

    // ---- e-mail at the end of the test (the same customer form of the section, sent without reloading the page) ----
    var emailBox = wrapper.querySelector('[data-the-method-email]');
    if (emailBox && formEl) {
      var emailInput = emailBox.querySelector('[data-the-method-email-input]');
      var emailStatus = emailBox.querySelector('[data-the-method-email-status]');
      var emailSubmit = emailBox.querySelector('[data-the-method-email-submit] button');
      var sending = false;

      function showEmailStatus(text) {
        emailStatus.textContent = text;
        emailStatus.hidden = !text;
      }

      var mailtoLink = emailBox.querySelector('[data-the-method-email-mailto]');

      function post(body) {
        return fetch(formEl.getAttribute('action') || '/contact', { method: 'POST', body: body, headers: { Accept: 'text/html' } }).then(function (response) {
          if (!response.ok) throw new Error('bad response');
        });
      }

      // Two sends, both without reloading the page: the newsletter subscription (the section's customer form) and a message to the store with
      // the e-mail, the answers and the recommended method, so the result can be sent back to that e-mail.
      function sendEmail() {
        if (sending) return;
        var value = (emailInput.value || '').trim();
        if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)) {
          showEmailStatus(emailBox.getAttribute('data-error-text') || '');
          emailInput.focus();
          return;
        }
        sending = true;
        if (emailSubmit) emailSubmit.setAttribute('aria-busy', 'true');

        var labels = {
          answers: emailBox.getAttribute('data-answers-label') || '',
          result: emailBox.getAttribute('data-result-label') || ''
        };
        var subject = emailBox.getAttribute('data-subject') || '';
        var text = resultText(labels).join('\n');

        var subscribe = new FormData(formEl);
        subscribe.set('contact[email]', value);

        var message = new FormData();
        message.set('form_type', 'contact');
        message.set('utf8', '\u2713');
        message.set('contact[email]', value);
        message.set('contact[body]', subject + '\n\n' + text);

        Promise.all([
          post(subscribe).then(function () { return true; }, function () { return false; }),
          post(message).then(function () { return true; }, function () { return false; })
        ]).then(function (results) {
          if (!results[0] && !results[1]) throw new Error('both failed');
          showEmailStatus(emailBox.getAttribute('data-success-text') || '');
          if (mailtoLink) {
            mailtoLink.setAttribute('href', 'mailto:' + encodeURIComponent(value).replace(/%40/g, '@') + '?subject=' + encodeURIComponent(subject) + '&body=' + encodeURIComponent(text));
            mailtoLink.hidden = false;
          }
          emailInput.value = '';
          track('email');
        }).catch(function () {
          showEmailStatus(emailBox.getAttribute('data-error-text') || '');
        }).then(function () {
          sending = false;
          if (emailSubmit) emailSubmit.removeAttribute('aria-busy');
        });
      }

      if (emailSubmit) emailSubmit.addEventListener('click', sendEmail);
      emailInput.addEventListener('keydown', function (event) {
        if (event.key === 'Enter') {
          event.preventDefault();
          sendEmail();
        }
      });
    }

    var whatsappLink = wrapper.querySelector('[data-the-method-whatsapp] a');
    if (whatsappLink) {
      whatsappLink.addEventListener('click', function () { track('whatsapp'); });
    }

    // ---- keyboard: 1-9 picks an option of the question in view, Enter confirms ----
    wrapper.addEventListener('keydown', function (event) {
      if (event.metaKey || event.ctrlKey || event.altKey || busy) return;
      var tag = event.target.tagName;
      if (tag === 'INPUT' || tag === 'TEXTAREA' || tag === 'SELECT') return;
      var key = currentPanelKey();
      if (key.indexOf('step-') !== 0) return;
      var step = key.split('-')[1];

      if (/^[1-9]$/.test(event.key)) {
        var choice = optionsForStep(step)[Number(event.key) - 1];
        if (choice) {
          event.preventDefault();
          choice.click();
        }
      }
    });

    // ---- swipe on phones: to the right goes back, to the left moves on once the question is answered ----
    var touchStartX = 0;
    var touchStartY = 0;
    if (panelsEl) {
      panelsEl.addEventListener('touchstart', function (event) {
        var touch = event.changedTouches[0];
        touchStartX = touch.clientX;
        touchStartY = touch.clientY;
      }, { passive: true });

      panelsEl.addEventListener('touchend', function (event) {
        if (busy || event.target.closest('input[type="range"]')) return;
        var touch = event.changedTouches[0];
        var dx = touch.clientX - touchStartX;
        var dy = touch.clientY - touchStartY;
        if (Math.abs(dx) < 70 || Math.abs(dy) > 40) return;
        var key = currentPanelKey();
        if (key.indexOf('step-') !== 0) return;
        var step = key.split('-')[1];

        if (dx > 0) {
          state.editing = false;
          goToStepIndex(-1);
        } else if (isAnswered(step)) {
          advance();
        }
      }, { passive: true });
    }

    // ---- restore where the visitor was (not when an e-mail is required to start, so that gate is never skipped) ----
    function restoreProgress() {
      if (requireEmail) return;
      var saved = null;
      try { saved = JSON.parse(localStorage.getItem(storageKey) || 'null'); } catch (e) {}
      if (!saved || !saved.panel || saved.panel === 'intro' || Date.now() - saved.ts > STORAGE_TTL) return;
      if (!panelFor(saved.panel)) return;

      Object.keys(saved.answers || {}).forEach(function (step) {
        var records = [];
        (saved.answers[step] || []).forEach(function (key) {
          var option = options.filter(function (item) { return item.getAttribute('data-key') === key; })[0];
          if (option) {
            records.push(recordFromOption(option));
          } else if (key.indexOf('-tone-') !== -1) {
            var toneRange = toneRanges.filter(function (item) { return key.indexOf(item.getAttribute('data-key-prefix') + '-tone-') === 0; })[0];
            records.push(toneRange ? toneRecord(toneRange, key.split('-tone-')[1]) : { key: key, label: 'Tono ' + key.split('-tone-')[1], weightSalicylic: 0, weightTca: 0, format: '', note: '', warn: false, warnNote: '' });
          }
        });
        if (records.length) state.answers[step] = records;
      });

      recomputeFromAnswers();
      Object.keys(state.answers).forEach(applySelectedState);

      var target = saved.panel === 'analyzing' ? 'result' : saved.panel;
      var fromEl = wrapper.querySelector('[data-the-method-panel]:not([hidden])');
      var toEl = panelFor(target);
      if (fromEl && fromEl !== toEl) fromEl.hidden = true;
      if (target === 'result') showResult();
      updateControls(target);
      toEl.hidden = false;
      if (state.warnings.length) updateWarningBanner();
    }

    restoreProgress();
  }

  function initAll() {
    document.querySelectorAll('[data-the-method]').forEach(function (wrapper) {
      if (wrapper.dataset.tmInitialized === 'true') return;
      wrapper.dataset.tmInitialized = 'true';
      initInstance(wrapper);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vc-whatsapp-button"] && !Shopify.designMode) return;
  try {
    
(function() {
  function initWhatsappButtons() {
    document.querySelectorAll('.vc-whatsapp-button-wrapper').forEach(function(wrapper) {
      if (wrapper.dataset.waInitialized === 'true') return;
      wrapper.dataset.waInitialized = 'true';

      var sectionId = wrapper.dataset.sectionId;

      // Aparición: tras los segundos configurados, cada vez que se carga una página (también al actualizarla o al
      // cambiar de página). En el editor del tema se muestra de inmediato para poder editarlo.
      var appearDelay = parseFloat(wrapper.dataset.appearDelay);

      if ((window.Shopify && window.Shopify.designMode) || !(appearDelay > 0)) {
        wrapper.classList.add('is-visible');
      } else {
        setTimeout(function() {
          wrapper.classList.add('is-visible');
        }, appearDelay * 1000);
      }

      if (wrapper.querySelector('.vc-whatsapp-button-text')) {
        wrapper.classList.add('has-text');
      }

      var button = wrapper.querySelector('.vc-whatsapp-button');
      if (!button) return;

      var hasAgents = button.dataset.hasAgents === 'true';
      var agentsList = wrapper.querySelector('.vc-whatsapp-agents-list');
      var overlay = wrapper.parentElement
        ? wrapper.parentElement.querySelector('.vc-whatsapp-overlay[data-section-id="' + sectionId + '"]')
        : null;

      function openWhatsapp(phoneNumber, message) {
        if (!phoneNumber) {
          console.error('WhatsApp button: Phone number is not set.');
          return;
        }
        var encodedMessage = encodeURIComponent(message || '');
        var whatsappUrl = 'https://wa.me/' + phoneNumber + '?text=' + encodedMessage;
        window.open(whatsappUrl, '_blank', 'noopener');
      }

      button.addEventListener('click', function(event) {
        event.preventDefault();
        if (hasAgents && agentsList) {
          agentsList.hidden = !agentsList.hidden;
          button.setAttribute('aria-expanded', String(!agentsList.hidden));
          if (overlay) overlay.hidden = agentsList.hidden;
          return;
        }
        openWhatsapp(button.dataset.phoneNumber, button.dataset.defaultMessage);
      });

      if (agentsList) {
        agentsList.querySelectorAll('.vc-whatsapp-agent-item').forEach(function(item) {
          item.addEventListener('click', function(event) {
            event.preventDefault();
            openWhatsapp(item.dataset.phoneNumber, item.dataset.message);
            agentsList.hidden = true;
            button.setAttribute('aria-expanded', 'false');
            if (overlay) overlay.hidden = true;
          });
        });

        document.addEventListener('click', function(event) {
          if (!wrapper.contains(event.target)) {
            agentsList.hidden = true;
            button.setAttribute('aria-expanded', 'false');
            if (overlay) overlay.hidden = true;
          }
        });
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initWhatsappButtons);
  } else {
    initWhatsappButtons();
  }

  document.addEventListener('shopify:section:load', initWhatsappButtons);

  // The product page's "WhatsApp" block (snippets/whatsapp-buy-button.liquid) opens this button's agent list instead
  // of going straight to one chat, as if the floating button had been tapped. Without agents, or when this button
  // isn't visible on the current screen, nothing is intercepted and that block's own wa.me link works as a plain link.
  if (!window.vcWhatsappProductTrigger) {
    window.vcWhatsappProductTrigger = true;

    document.addEventListener('click', function(event) {
      var trigger = event.target.closest && event.target.closest('.whatsapp-buy-button');
      if (!trigger) return;

      var floating = document.querySelector('.vc-whatsapp-button[data-has-agents="true"]');
      var wrapper = floating && floating.closest('.vc-whatsapp-button-wrapper');
      if (!floating || !wrapper || wrapper.getClientRects().length === 0) return;

      event.preventDefault();
      // This button's own "click outside closes the list" handler would otherwise see this click (its target is
      // outside the wrapper) and close the list right after it opens.
      event.stopImmediatePropagation();

      wrapper.classList.add('is-visible');
      floating.click();
    }, true);
  }
})();

  } catch(e) { console.error(e); }
})();
})();
